import Banner1 from './Banner1';
import Banner2 from './Banner2';
import Banner3 from './Banner3';
import Banner4 from './Banner4';
import Banner5 from './Banner5';

export { Banner1, Banner2, Banner3, Banner4, Banner5 };
